<template>
  <b-modal
    id="client-modal"
    size="lg"
    :title="$t('clients.client_add')"
    :ok-title="$t('generals.save')"
    :cancel-title="$t('generals.cancel')"
    cancel-variant="danger"
    ok-variant="success"
    no-close-on-backdrop
    @hide="$emit('modalClosed')"
    @ok="onSubmit"
  >
    <validation-observer ref="infoClient">
      <!-- {{ phones }} -->
      <!-- {{ client }} -->
      <b-row>
        <b-col md="6">
          <b-form-group :label="$t('clients.type_of_ownership')">
            <validation-provider
              #default="{ errors }"
              name="title"
              rules="required"
            >
              <v-select
                v-model="client.entity"
                :options="entityOptions"
                label="title"
                :reduce="(entity) => entity.id"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <b-col
          md="6"
        >
          <b-form-group
            v-if="client.entity === 'yuridiskiy'"
            :label="$t('clients.contact_number')"
          >
            <validation-provider
              #default="{ errors }"
              name="phone_number"
              rules="required"
            >
              <cleave
                id="phone"
                v-model="phones"
                class="form-control"
                :raw="true"
                :options="optionsPhoneContact"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
          <b-form-group
            v-if="client.entity === 'fizichiskiy'"
            :label="$t('clients.client_gender')"
          >
            <validation-provider
              #default="{ errors }"
              name="Gender"
              rules="required"
            >
              <v-select
                v-model="client.gender"
                :options="genderOptions"
                :get-option-label="(option) => option.title[$i18n.locale]"
                :reduce="(entity) => entity.id"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <b-col
          v-if="client.entity == 'fizichiskiy'"
          md="6"
        >
          <b-form-group :label="$t('clients.full_name')">
            <validation-provider
              #default="{ errors }"
              name="name"
              rules="required"
            >
              <b-form-input v-model="client.title" />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <b-col
          v-if="client.entity === 'fizichiskiy'"
          md="6"
        >
          <b-form-group :label="$t('clients.contact_number')">
            <validation-provider
              #default="{ errors }"
              name="phone_number"
              rules="required"
            >
              <b-form-input
                v-model="phones"
                type="text"
                placeholder="+998-xx-xxx-xx-xx"
                @keyup="formatPhone"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <b-col
          v-if="client.entity == 'yuridiskiy'"
          md="6"
        >
          <b-form-group :label="$t('clients.company')">
            <validation-provider
              #default="{ errors }"
              name="company"
              rules="required"
            >
              <b-form-input v-model="client.title" />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <b-col
          v-if="client.entity == 'yuridiskiy'"
          md="6"
        >
          <b-form-group :label="$t('clients.field_of_activity')">
            <validation-provider
              #default="{ errors }"
              name="spheres"
              rules="required"
            >
              <v-select
                v-model="client.sphere_of_activity"
                :options="spheresOptions"
                :reduce="(sphere) => sphere.id"
                label="title"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <b-col
          v-if="client.entity == 'yuridiskiy'"
          md="6"
        >
          <b-form-group :label="$t('clients.email')">
            <validation-provider
              #default="{ errors }"
              name="spheres"
              rules="email"
            >
              <b-form-input v-model="emails" />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <b-col md="6">
          <b-form-group :label="$t('clients.type_of_appeal')">
            <validation-provider
              #default="{ errors }"
              name="client_request"
            >
              <v-select
                v-model="client.client_request"
                label="title"
                multiple
                :options="GET_CLIENT_REQUESTS"
                :reduce="(target) => target.id"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <b-col md="6">
          <b-form-group :label="$t('clients.payment_type')">
            <!-- <validation-provider
              #default="{ errors }"
              name="payment_type"
            > -->
            <v-select
              v-model="client.payment_type"
              :options="GET_CLIENT_PAYMENT_TYPES"
              label="title"
              :reduce="(target) => target.id"
            />
            <!-- <small class="text-danger">{{ errors[0] }}</small> -->
            <!-- </validation-provider> -->
          </b-form-group>
        </b-col>

        <b-col md="6">
          <b-form-group :label="$t('clients.client_wishes')">
            <!-- <validation-provider
              #default="{ errors }"
              name="client_interested"
            > -->
            <v-select
              v-model="client.client_interested"
              :options="GET_CLIENT_INTERESTED"
              label="title"
              multiple
              :reduce="(target) => target.id"
            />
            <!-- <small class="text-danger">{{ errors[0] }}</small> -->
            <!-- </validation-provider> -->
          </b-form-group>
        </b-col>

        <!-- <b-col md="6">
          <b-form-group label="Менеджер">
            <validation-provider
              #default="{ errors }"
              name="manager"
              rules="required"
            >
              <v-select
                v-model="client.manager"
                :options="managerOptions"
                :reduce="manager => manager.id"
                label="first_name"
                disabled
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col> -->

        <b-col
          v-if="client.entity == 'yuridiskiy'"
          md="6"
        >
          <b-form-group :label="$t('clients.company_employee')">
            <validation-provider
              #default="{ errors }"
              name="company_employee"
            >
              <b-form-input v-model="client.company_employee" />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <b-col
          v-if="client.entity == 'yuridiskiy'"
          md="6"
        >
          <b-form-group :label="$t('clients.phone_number')">
            <validation-provider
              #default="{ errors }"
              name="employee_number"
            >
              <cleave
                id="employee_number"
                v-model="client.employee_number"
                class="form-control"
                :raw="true"
                :options="optionsPhone"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <b-col md="6">
          <b-form-group :label="$t('clients.how_did_you_know_about_us')">
            <validation-provider
              #default="{ errors }"
              name="status"
            >
              <v-select
                v-model="client.target"
                :options="getTargets"
                label="title"
                :reduce="(target) => target.id"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <!--<b-col md="6">
          <b-form-group :label="client.entity === 'yuridiskiy' ? $t('clients.day_of_foundation_of_the_company') : $t('clients.clients_birthday')">
            <flat-pickr
              v-model="client.birth_date"
              class="form-control bg-white"
              style="max-width: 250px;"
              :config="configdateTimePicker"
            />
          </b-form-group>
        </b-col> -->

        <b-col md="12">
          <b-form-group :label="$t('clients.note')">
            <b-form-textarea
              v-model="client.description"
              rows="3"
            />
          </b-form-group>
        </b-col>
      </b-row>
    </validation-observer>
  </b-modal>
</template>

<script>
import {
  BModal,
  BRow,
  BCol,
  BFormInput,
  BFormGroup,
  BFormTextarea,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import { required, email, length } from '@validations'
import Cleave from 'vue-cleave-component'
import { mapActions, mapGetters } from 'vuex'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
// import flatPickr from 'vue-flatpickr-component'
// eslint-disable-next-line import/no-extraneous-dependencies
import { Russian } from 'flatpickr/dist/l10n/ru'
import { getUserData } from '@/auth/utils'

export default {
  components: {
    BModal,
    BRow,
    BCol,
    BFormInput,
    BFormGroup,
    BFormTextarea,
    vSelect,
    ValidationProvider,
    ValidationObserver,
    Cleave,
    // flatPickr,
  },
  props: {
    statusesclient: {
      type: null,
      required: false,
    },
    clientInfo: {
      type: null,
      required: false,
      // default() {
      //   return {
      //     title: '',
      //     description: '',
      //     // emails: [],
      //     sphere_of_activity: null,
      //     // manager: null,
      //     phones: [],
      //     // status_of_client: null,
      //     // groups: [],
      //     entity: 'fizichiskiy',
      //     company_employee: '',
      //     employee_number: '',
      //   // gender: 'man',
      //   // inn: "",
      //   // oked: '',
      //   // address: ''
      //   }
      // },
    },
  },
  data() {
    return {
      required,
      email,
      length,
      emails: '',
      phones: '',
      phoneValue: '',
      configdateTimePicker: {
        altInput: true,
        allowInput: true,
        altFormat: 'd.m.Y',
        dateFormat: 'Y-m-d',
        locale: Russian,
      },
      client: {
        title: '',
        description: '',
        // emails: [],
        sphere_of_activity: null,
        // manager: null,
        phones: [],
        // status_of_client: null,
        // groups: [],
        entity: 'fizichiskiy',
        company_employee: '',
        employee_number: '',
        // gender: 'man',
        // inn: "",
        // oked: '',
        // address: ''
      },
      genderOptions: [
        {
          title: {
            uz: 'Erkak',
            ru: 'Мужской',
            en: 'Male',
          },
          id: 'man',
        },
        {
          title: {
            uz: 'Ayol',
            ru: 'Женский',
            en: 'Female',
          },
          id: 'woman',
        },
      ],
      entityOptions: [
        {
          title: this.$t('clients.entity'),
          id: 'yuridiskiy',
        },
        {
          title: this.$t('clients.natural_person'),
          id: 'fizichiskiy',
        },
      ],
      optionsPhone: {
        prefix: '+998',
        blocks: [4, 2, 3, 2, 2],
        delimiter: '-',
      },
      optionsPhoneContact: {
        prefix: '+998',
        blocks: [4, 2, 3, 2, 2],
        delimiter: '-',
      },
    }
  },
  computed: {
    ...mapGetters('clients', [
      'getSpheresOfActivity',
      'getTargets',
      'GET_CLIENT_PAYMENT_TYPES',
      'GET_CLIENT_INTERESTED',
      'GET_CLIENT_REQUESTS',
    ]),
    managerOptions() {
      return [getUserData()]
    },
    spheresOptions() {
      return this.getSpheresOfActivity.map(sphere => ({
        title: sphere.title.ru,
        id: sphere.id,
      }))
    },
  },
  watch: {
    clientInfo() {
      console.log(this.clientInfo.phones[0])
      JSON.stringify(this.clientInfo)
      this.client = this.clientInfo
      // eslint-disable-next-line
      this.phones = this.clientInfo.phones[0]
      // this.phones = `+${this.clientInfo.phones[0].replace(/[^0-9]+/gi, '')}`
    },
  },
  mounted() {
    this.client.manager = getUserData().id
    this.FETCH_ACTIVITY_SPHERES()
    this.FETCH_CLIENT_INTERESTED()
    this.FETCH_CLIENT_PAYMENT_TYPES()
    this.FETCH_CLIENT_REQUESTS()
    this.FETCH_TARGETS()
  },
  methods: {
    setTimeout: (a, v) => setTimeout(a, v),
    ...mapActions('clients', [
      'FETCH_ACTIVITY_SPHERES',
      'FETCH_TARGETS',
      'ADD_NEW_CLIENT',
      'FETCH_CLIENT_PAYMENT_TYPES',
      'FETCH_CLIENT_INTERESTED',
      'FETCH_CLIENT_REQUESTS',
    ]),
    onSubmit(bvModalEvt) {
      bvModalEvt.preventDefault()

      this.$refs.infoClient.validate().then(async success => {
        if (success) {
          this.client.phones = [this.phones.replace(/[^0-9]+/gi, '')]
          this.client.emails = [this.emails]

          if (this.client.entity === 'fizichiskiy') {
            delete this.client.sphere_of_activity
          }

          this.ADD_NEW_CLIENT(this.client).then(resp => {
            this.$nextTick(() => {
              this.$bvModal.hide('client-modal')
            })
            this.$emit('refresh', resp)
            this.emails = ''
            this.phones = ''
            this.client = {
              title: '',
              description: '',
              emails: [],
              sphere_of_activity: null,
              manager: null,
              phones: [],
              status_of_client: null,
              target: null,
              entity: 'fizichiskiy',
            }
          })
        }
      })
    },
    formatPhone(event) {
      if (['Arrow', 'Backspace', 'Shift'].includes(event.key)) {
        this.preventNextIteration = true
        return
      }
      if (this.preventNextIteration) {
        this.preventNextIteration = false
        return
      }
      const [first] = this.phones.replace(/-/g, '').match(/(\d{1,12})/g)
      this.phoneValue = first

      // Format display value based on calculated currencyValue
      this.phones = this.phoneValue.replace(/(\d{3})(\d{2})(\d{3})(\d{2})(\d{2})/g, '+$1-$2-$3-$4-$5')
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import "@core/scss/vue/libs/vue-flatpicker.scss";

</style>
